export default "__VITE_ASSET__BJC9DYIF__"